import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import PageSEO from '@/components/base/PageSEO';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <PageSEO
        title="Página Não Encontrada — CSSBuy Spreadsheet"
        description="A página que você procura não foi encontrada. Volte ao hub principal da CSSBuy Spreadsheet para descobrir os melhores produtos para importar da China."
        canonicalPath={location.pathname}
        noindex={true}
      />
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-800 mt-6">Esta página não foi encontrada</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <Link
          to="/"
          className="whitespace-nowrap inline-flex items-center justify-center mt-6 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-semibold rounded-md hover:bg-foreground-800 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line mr-2 w-4 h-4 flex items-center justify-center"></i>
          Voltar ao Hub Principal
        </Link>
      </div>
    </div>
  );
}